export enum Checkout {
  ADDRESS = 'adress',
  PAYMENT = 'payment',
  MESSAGE = 'message'
}

export enum Card {
  RESTAURANT = 'restaurant',
  DISH = 'dish'
}
